import { ApiService } from './../../../services/apiservice/apiservice.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../services/config/config.service';
import { SearchService } from '../../../services/search/search.service';

@Injectable()
export class EditSidenavService {
  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
    private _searchService: SearchService,
  ) {}

  zeroResultsTextBlock$ = this._searchService.zeroResultsTextBlock$;

  saveZeroResultsTextBlock(data): Observable<any> {
    const result = this._searchService.saveZeroResultsTextBlock(data);
    this.zeroResultsTextBlock$ = this._searchService.zeroResultsTextBlock$;
    return result;
  }

  getNewRDP(): Observable<any> {
    const url = this._configService.agApi + '/opacSettings/SolrNextRecordDisplayProfile';
    return this._apiService.get(url);
  }

  updateNewRDP(data): Observable<any> {
    const url = this._configService.agApi + '/opacSettings/SolrNextRecordDisplayProfile';
    return this._apiService.put(url, data);
  }

  uploadImage(data): Observable<any> {
    const url = this._configService.expressApi + '/file/upload';
    return this._apiService.post(url, data);
  }
}
